import { OneColumn } from 'components/page';
import { ManutencaoReembolsoGrid, ManutencaoReembolsoGridFilter } from 'pages/financeiro/reembolso/manutencao-reembolso/components/';

export function ManutencaoReembolsoListComp() {
    return (
        <OneColumn title="Manutenção/Download de Reembolsos" goBackButton>
            <ManutencaoReembolsoGridFilter />

            <ManutencaoReembolsoGrid />
        </OneColumn>
    );
}
